<template>
  <div id="WhatsPinPos" >
    <b-container>
        <template v-if="isMobile(true)">
            <b-row>
                <b-col sm="12" lg="12">
                    <h3 class="title" v-html="acf.acf.title"></h3>
                    <p class="description" v-html="acf.acf.description"></p>
                    <b-button class="getintouch" @click="scroll()">Get in touch</b-button>
                </b-col>
            </b-row>  
        </template>
        <template v-else>
            <b-row>
                <b-col sm="12" lg="6">
                    <h3 class="title" v-html="acf.acf.title"></h3>
                    <p class="description" v-html="acf.acf.description"></p>
                    <b-button class="getintouch" @click="scroll()">Get in touch</b-button>
                </b-col>
                <b-col sm="12"  lg="6">
                    <b-row>
                        <b-col>
                            <img class="images" src="https://wp-ocssport.ocs-sport.com/pinpos/wp-content/uploads/sites/9/2025/08/Pin-Postition-Courses.png">
                        </b-col>
                        <b-col>
                            <img class="images" src="https://wp-ocssport.ocs-sport.com/pinpos/wp-content/uploads/sites/9/2025/08/Pin-Postition-Courses-Info.png">
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>            
        </template>

    </b-container>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'Whats Pin Pos',
  components: {

  },
  data: function() {
    return {
      acf: [],
    };
  },
  methods: {
        isMobile() {
            if( screen.width <= 1280 ) {
                return true;
            }
            else {
                return false;
            }
        },
        scroll() {
            var score = document.getElementById("contactButton");
            score.scrollIntoView({
                behavior: "smooth",
                block: "start",
                inline: "nearest",
            });
        },
  },
  mounted() {
    axios //add API Call
        .get(
           process.env.VUE_APP_API_URL + 'pinpos' + "/wp-json/wp/v2/pages/13" + '?randomadd=' +
          new Date().getTime()
        ) // Page number changed on each page based on JSON page id you are calling
        .then((response) => (
            this.acf = response.data
        )); //API data wanted pulled out
  },
}
</script>
<style scoped>
#WhatsPinPos {
    padding-top: 100px;
    padding-bottom: 100px;
}
.images {
    width: 100%;
}
.title {
    font-size: 50px;
    font-family: DIN Condensed, Bold;
    color: #0054E8;
    text-align: left;
    padding-bottom: 50px;
}
p {
    text-align: left;
    font-size: 24px;
    color: #000000;
    padding-bottom: 50px;
}
button.getintouch {
    padding: 14px 14px 14px 14px;
    background-color: #2CD55B;
    width: 330px;
    height: 64px;
    color: #fff;
    border-radius: 14px;
    border-color: #2CD55B;
    font-size: 24px;
    font-weight: bold;
    float: left;
}
button.getintouch:hover {
    padding: 14px 14px 14px 14px;
    background-color: #2D2D39;
    width: 330px;
    height: 64px;
    color: #fff;
    border-radius: 14px;
    border-color: #2D2D39;
    font-size: 24px;
    font-weight: bold;
    float: left;
}

/* Css for mobile */
@media only screen and (max-width: 1280px) {
    #WhatsPinPos {
        padding-top: 50px;
        padding-bottom: 50px;
    }
    .title {
        padding-bottom: 20px;
    }
    p {
        text-align: left;
        font-size: 18px;
        color: #000000;
        padding-bottom: 10px;
    }
    button.getintouch {
        padding: 14px 14px 14px 14px;
        background-color: #2CD55B;
        width: 100%;
        height: 64px;
        color: #fff;
        border-radius: 14px;
        border-color: #2CD55B;
        font-size: 18px;
        font-weight: bold;
        float: left;
    }
    button.getintouch:hover {
        padding: 14px 14px 14px 14px;
        background-color: #2D2D39;
        width: 100%;
        height: 64px;
        color: #fff;
        border-radius: 14px;
        border-color: #2D2D39;
        font-size: 18px;
        font-weight: bold;
        float: left;
    }
}
</style>
